module.exports = __webpack_public_path__ + "static/media/sign-in-logo-christmas.b972d52a.svg";